import axios from 'axios'

export default {
  sendContactMail(mail) {
    return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/mail/contact', mail).then((response) => {
      return response
    })
  },
  sendBecomeCustomerMail(mail) {
    return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/mail/becomecustomer', mail).then((response) => {
      return response
    })
  },
  sendOrderConfirmationMail(orderId) {
    return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/mail/order/' + orderId).then((response) => {
      return response
    })
  },
  sendQuoteConfirmationMail(data) {
    return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/mail/quote', { order: data.order, products: data.products, admin: data.admin }).then((response) => {
      return response
    })
  }
}
